import BFLImage from "@repo/shared-ui/BFLImage";
import { FC } from "react";
import {
  IPO_PLACEHOLDER,
  IPO_TEXT,
  IPO_TYPE,
  PRE_APPLY,
} from "./IpoListConstants";
import { IpoListFunctions } from "./IpoListFunctions";
import { IAllIpoListItem } from "../../interfaces/IpoList.interface"

const IpoListItem: FC<IAllIpoListItem> = (props) => {
  const {
    getInfoValue,
    getInfoLabel,
    getStockPriceStatus,
    getIpoDateDisplay,
    getStockStatus,
    closingText,
  } = IpoListFunctions();

  return (
    <div className="border border-[#e5e5e5] rounded-md">
      <div className="flex justify-between min-h-[88px] px-4 py-3 gap-3 md:flex-row flex-col">
        <div className="flex items-center gap-2">
          <BFLImage
            src={props?.itemDetails?.companyIcon?.trim() || IPO_PLACEHOLDER}
            alt={props?.itemDetails?.name ?? ""}
            width={56}
            height={56}
            quality={20}
            className="md:w-[56px] md:h-[56px] w-[40px] h-[40px] border border-[#e5e5e5] rounded-full p-[4px] md:p-[6px]"
          />
          <div className="flex flex-col gap-1">
            <div className="text-[#1a1a1a] text-[14px] md:text-[18px] font-medium md:w-[350px]">
              {props?.itemDetails?.name}
              {IPO_TEXT}
            </div>

            {/* Closing */}
            {props?.itemDetails?.closing && (
              <div className="flex items-center gap-1 min-h-[22px] w-fit text-[#B40000] bg-[#fff1f1] text-[10px] md:text-[12px] px-1.5 rounded">
                <i className="icomoon before:content-['\e982'] text-[10px] md:text-[12px]" />
                <div>{closingText(props?.itemDetails?.closing)}</div>
              </div>
            )}

            {/* Early Access */}
            {props?.itemDetails?.earlyAccess &&
              props?.ipoType !== IPO_TYPE.CLOSED && (
                <div className="flex items-center gap-1 min-h-[22px] w-fit text-[#faba0a] bg-[#fef0ca] text-[10px] md:text-[12px] px-1.5 rounded">
                  <i className="icomoon before:content-['\e93f'] text-[10px] md:text-[12px]" />
                  <div className="text-[#1a1a1a]">{PRE_APPLY}</div>
                </div>
              )}
          </div>
        </div>

        {/* Info Section */}
        <div className="flex justify-between items-center gap-10 md:gap-20">
          {/* Date Info */}
          <div className="flex flex-col gap-1">
            <div className="text-[#666666] md:text-[14px] text-[10px] font-normal">
              {props?.ipoType === IPO_TYPE.CLOSED
                ? props?.listingDateText
                : props?.biddingPeriodText}
            </div>
            <div className="text-[#1a1a1a] md:text-[14px] text-[12px] font-medium">
              {getIpoDateDisplay(
                props?.itemDetails,
                props?.ipoType,
                props?.tbaText
              )}
            </div>
          </div>

          {/* Investment / Price Info */}
          <div className="flex flex-col gap-1">
            <div className="text-[#666666] text-[10px] md:text-[14px] font-normal">
              {getInfoLabel(
                props?.ipoType,
                props?.minimumInvestmentText,
                props?.bidPriceText,
                props?.listingGainText
              )}
            </div>

            <div
              className={`text-right ${
                props?.ipoType === IPO_TYPE.CLOSED &&
                props?.itemDetails.listingdayRes === "-"
                  ? "md:text-left"
                  : ""
              }`}
            >
              {props?.ipoType === IPO_TYPE.CLOSED &&
              !(props?.itemDetails.listingdayRes === "-") ? (
                <div className={`flex items-center md:text[14px] text-[12px] ${getStockPriceStatus(
                      props?.itemDetails
                    )}`}>
                  <span
                    className="text-sm mr-1"
                  >
                    {getInfoValue(props?.itemDetails, props?.ipoType)}
                  </span>
                  <i className={`text-sm icomoon ${getStockStatus(props?.itemDetails)}`} />
                </div>
              ) : (
                <div className="text-[#1a1a1a] md:text-[14px] text-[12px] font-medium">
                  {getInfoValue(
                    props?.itemDetails,
                    props?.ipoType,
                    props?.tbaText
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IpoListItem;
